var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 84,
    viewBox: "0 0 69 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4E443D",
    strokeWidth: 6,
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7205882 59.2941176L49.1029412 59.2941176 28.7205882 59.2941176zM12.9705882 59.2941176L20.3823529 59.2941176 12.9705882 59.2941176zM28.7205882 41.6911765L49.1029412 41.6911765 28.7205882 41.6911765zM12.9705882 41.6911765L20.3823529 41.6911765 12.9705882 41.6911765zM28.7205882 23.1617647L49.1029412 23.1617647 28.7205882 23.1617647zM12.9705882 23.1617647L20.3823529 23.1617647 12.9705882 23.1617647z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.7470588,77.6803476 L52.2529412,77.6803476 C57.9833471,77.6803476 62.6294118,73.0644521 62.6294118,67.3712567 L62.6294118,15.8258021 C62.6294118,10.1326067 57.9833471,5.51671123 52.2529412,5.51671123 L10.7470588,5.51671123 C5.01665294,5.51671123 0.370588235,10.1326067 0.370588235,15.8258021 L0.370588235,67.3712567 C0.370588235,73.0644521 5.01665294,77.6803476 10.7470588,77.6803476 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2323529,0.362165775 L45.7676471,0.362165775"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.3f169a0b08a185dde222c5a1bb95be81.svg";
export { ForwardRef as ReactComponent };